import {inject, Injectable} from '@angular/core';
import {MatSnackBar} from "@angular/material/snack-bar";
import {defaultSnackbarParams} from "../models/default-snackbar-params";
import {SnackbarParams} from "../types/snackbar-params.types";
import {SnackbarCustomComponent} from "../../shared/components/ui/snackbar-custom/snackbar-custom.component";

@Injectable({
  providedIn: 'root'
})
export class SnackbarService {
  private snackBar: MatSnackBar = inject(MatSnackBar);

  public showMessage(params: SnackbarParams) {
    const snackbarConfig: SnackbarParams = {
      ...defaultSnackbarParams,
      ...params
    };

    this.snackBar.openFromComponent(SnackbarCustomComponent, {
      ...snackbarConfig.config,
      data: snackbarConfig
    });
  }

  public infoShowMessage(message: string) {
    this.showMessage({
      type: 'info',
      message: message
    });
  }

  public successShowMessage(message: string) {
    this.showMessage({
      type: 'success',
      message: message
    });
  }
}


